import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./medicine.scss"
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAllMedicineList, getDoctorMedicineList } from '../../../../store/slices/prescriptionSlice';
import { prescriptionAddSubDocument, prescriptionRemoveSubDocument, prescriptionUpdateSubDocument } from '../../../../service/api/prescription';
import CustomModal from '../../../common/modal/modal';
import {
    faArrowAltCircleDown,
    faArrowAltCircleUp,
    faArrowCircleDown,
    faArrowDown,
    faArrowUp,
    faEdit,
    faTrash
} from "@fortawesome/free-solid-svg-icons";
import MedicineSigForm from './medicine-sig-form/medicine-sig-form';
import UniversalLoaderForComponent from '../../../loader/universalLoaderForComponent';
import { templateAddSubDocument, templateRemoveSubDocument, templateUpdateSubDocument } from '../../../../service/api/template';
import { put } from '../../../../utils/fetchAPI';
import { resolveActingDoctorId } from '../../../../utils/common-funtions/common';
import { showErrorToast } from '../../../../utils/toaster-alert';
import { DraggableList } from '../../../common/draggable-list/drgabble-list';
const Medicine = ({ visitDetails, updateState, templateDetails, templateId, doctorId }) => {

    let { isMedicineListLoading, medicineList, doctorMedicineList,
        isDoctorMedicineListLoading, isLoading, isNoMedicine } = useSelector(
            (state) => state.prescription
        );
    let { user, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
    // Whose "my drug list" to load: the template/visit owner doctor, the doctorId
    // passed in (template editor), else the acting doctor (assistant -> selected doctor).
    const actingDoctorId =
        templateDetails?.doctor ||
        visitDetails?.doctor ||
        doctorId ||
        resolveActingDoctorId({ user, selectedRole, selectedDoctor });
    const [show, setShow] = useState(false)
    const [sig, setSig] = useState("")
    const [selectedMedicine, setSelectedMedicine] = useState({})
    const [docMedicineShow, setDocMedicineShow] = useState(true)
    const [searchType, setSearchType] = useState("name")
    const [myMedicineSearchType, setMyMedicineSearchType] = useState("name")
    const [info, setInfo] = useState({})
    const [isDoubleClick, setIsDoubleClick] = useState(false)
    const [isDocMedicineUp, setIsDocMedicineUp] = useState(false)
    const [searchString, setSearchString] = useState('')
    const [ownMedicineSearchString, setOwnMedicineSearchString] = useState('')
    const timeoutIdRef = useRef(null)
    const [prescribedMedicines, setPrescribedMedicines] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false)

    const dispatch = useDispatch()
    useEffect(() => {
        if (!actingDoctorId) return
        const payload = { doctorId: actingDoctorId, search: "" }
        dispatch(getDoctorMedicineList(payload))
    }, [actingDoctorId])

    const medicineSearch = (value, event) => {
        event.preventDefault()
        if (value?.length > 0 && /^\s*$/.test(value) == false) {
            let payLoad = {
                key: searchType, search: value.trim(), manufacturerName: "", medicinePriority: false
            }
            if (user?.user?.details?.sponsor == "true") {
                payLoad.manufacturerName = user?.user?.organization?.manufacturerName
                payLoad.medicinePriority = user?.user?.organization?.medicinePriority
            }

            dispatch(getAllMedicineList(payLoad))
            setDocMedicineShow(false)
        }
        else setDocMedicineShow(true)
    }


    const medicineSearchWithTimeOut = (value, event) => {
        setSearchString(value)
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { medicineSearch(value, event) }, 500);
    };

    const checkAndAddMedicine = (medicine, check = false) => {
        // optional
        if (medicine?.sig?.length && check) {
            medicineAddToPrescription(medicine)
        }
        else if (check) {
            setSelectedMedicine(medicine)
            setShow(true)
        }
        else
            medicineAddToPrescription(medicine)
        setOwnMedicineSearchString("")
    }

    const addNewMedicine = () => {
        setSelectedMedicine({})
        setShow(true)
    }

    function checkMedicineExists(medicines, medicineName) {
        // Handle edge cases
        if (!medicines || !Array.isArray(medicines)) {
            return false;
        }

        if (!medicineName || typeof medicineName !== 'string') {
            return false;
        }

        // Check if medicine exists (case-insensitive comparison)
        return medicines.some(med =>
            med.name && med.name.toLowerCase() === medicineName.toLowerCase()
        );
    }

    const medicineAddToPrescription = async (medicine) => {
        setIsSubmitting(true)
        if (templateId) {
            let payLoad = {
                // doctorId: medicine?.doctorId,
                power: medicine?.power || "",
                type: medicine?.type || "",
                generic: medicine?.generic || "",
                manufacturer: medicine?.manufacturer || "",
                medicine: medicine?.medicineId || null,
                sig: medicine?.sig || "",
                name: medicine?.name || "",
                route: medicine?.route || "",
                take: medicine?.take || "",
                frequency: medicine?.frequency || "",
                repeat: medicine?.repeat || "",
                duration: medicine?.duration || "",
                doctorMedicineId: medicine?._id || medicine?.doctorMedicineId || "",
                addToDoctorMedicine: medicine?.addToDoctorMedicine || false
            }


            // if (checkMedicineExists(prescribedMedicines, payLoad?.name)) {
            //     setIsSubmitting(false)
            //     showErrorToast(`${payLoad?.name} is already in the prescription`)
            //     return; // Exit early if medicine exists
            // }

            await templateAddSubDocument('medicines', payLoad, templateId)
                .then((res) => {
                    if (res.status === 200) {
                        setPrescribedMedicines(res?.data?.medicines)
                        setIsSubmitting(false)
                        setPrescriptionMedicineToState(res?.data?.medicines)
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    const searchInput = document.getElementById("my-drug-list")
                    if (searchInput) searchInput.value = ""
                    const payload = { doctorId: actingDoctorId, search: "" }
                    dispatch(getDoctorMedicineList(payload))
                    setIsSubmitting(false)
                });
        }
        else {
            let payLoad = {
                // doctorId: medicine?.doctorId,
                power: medicine?.power || "",
                type: medicine?.type || "",
                generic: medicine?.generic || "",
                manufacturer: medicine?.manufacturer || "",
                medicine: medicine?.medicineId || null,
                sig: medicine?.sig || "",
                name: medicine?.name || "",
                take: medicine?.take || "",
                route: medicine?.route || "",
                frequency: medicine?.frequency || "",
                repeat: medicine?.repeat || "",
                duration: medicine?.duration || "",
                doctorMedicineId: medicine?._id || medicine?.doctorMedicineId || "",
                addToDoctorMedicine: medicine?.addToDoctorMedicine || false
            }

            // if (checkMedicineExists(prescribedMedicines, payLoad?.name)) {
            //     setIsSubmitting(false)
            //     showErrorToast(`${payLoad?.name} is already in the prescription`)
            //     return; // Exit early if medicine exists
            // }

            await prescriptionAddSubDocument('medicines', payLoad, visitDetails?._id)
                .then((res) => {
                    if (res.status === 200) {
                        setPrescribedMedicines(res?.data?.medicines)
                        updateState(res?.data)
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    const searchInput = document.getElementById("my-drug-list")
                    if (searchInput) searchInput.value = ""
                    const payload = { doctorId: actingDoctorId, search: "", type: myMedicineSearchType || "name" }
                    dispatch(getDoctorMedicineList(payload))
                    setIsSubmitting(false)
                });
        }

    }

    const deleteMedicineFun = async (medicine) => {
        setIsSubmitting(true)
        if (templateId) {
            templateRemoveSubDocument('medicines', { _id: medicine?._id }, templateId)
                .then((res) => {
                    if (res?.status === 200) {
                        setPrescribedMedicines(res?.data?.medicines)
                        setIsSubmitting(false)
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => { setIsSubmitting(false) });
        }
        else {
            await prescriptionRemoveSubDocument('medicines', { _id: medicine?._id }, visitDetails?._id)
                .then((res) => {
                    if (res?.status === 200) {
                        setPrescribedMedicines(res?.data?.medicines)
                        updateState(res?.data)
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => { setIsSubmitting(false) })
        }
    }

    const upDateMedicineFun = async (val, type, id) => {

        if (templateId) {
            let payload = {
                _id: id,
            }
            if (type === "sig") {
                payload["medicines.$.sig"] = val
            }
            if (type === "duration") {
                payload["medicines.$.duration"] = val
            }
            if (type == "name") {
                payload["medicines.$.name"] = val
            }
            if (val) {
                await templateUpdateSubDocument("medicines", payload, templateId).then((res) => {
                    if (res.status == 200) {
                        setPrescribedMedicines(res?.data?.medicines)
                    }
                })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally()
            }

        } else {
            let payload = {
                _id: id,
            }
            if (type === "sig") {
                payload[`medicines.$.sig`] = val
            }
            if (type === "duration") {
                payload[`medicines.$.duration`] = val
            }
            if (type == "name") {
                payload["medicines.$.name"] = val
            }
            // optional
            // if (val) {
            await prescriptionUpdateSubDocument("medicines", payload, visitDetails?._id).
                then((res) => {
                    if (res.status == 200) {
                        setPrescribedMedicines(res?.data?.medicines)
                        updateState(res?.data)
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally()
            // }

        }
    }


    const setInfoFun = (key, value, type, id) => {
        let temp = { ...info };
        setInfo({ ...temp, [key]: value });
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { upDateMedicineFun(value, type, id) }, 700);
    };


    const onBlurSetInfo = (key, value, type, id) => {
        let temp = { ...info };
        setInfo({ ...temp, [key]: value });
    };

    const onBlurSubmit = (value, type, id) => {
        upDateMedicineFun(value, type, id)
    }

    const checkOrganizationFun = (name = "Popular") => {
        if (user?.user?.details?.sponsor == "true")
            return (name.startsWith(user?.user?.organization?.manufacturerName))
        else return false
    }
    const medicineSearchFromMyList = (value, type) => {
        // e.preventDefault()
        const payload = { doctorId: actingDoctorId, search: value?.trim(), type: type }
        dispatch(getDoctorMedicineList(payload))
    }

    const medicineSearchFromMyListWithTimeOut = (value, type) => {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(() => { medicineSearchFromMyList(value, type) }, 500);
    };


    const dragUp = (index, prescribedMedicines, id) => {
        let medicines = [...prescribedMedicines]
        if (medicines?.length > 0) {
            [medicines[index - 1], medicines[index]] = [medicines[index], medicines[index - 1]]
        }

        // const replacedElement = document.getElementById(`medicine-${id}`);
        setPrescribedMedicines(medicines)
        setSwapMedicinesToVisit(medicines)

    }
    const dragDown = (index, prescribedMedicines, id) => {
        let medicines = [...prescribedMedicines]
        if (medicines?.length > 0) {
            [medicines[index], medicines[index + 1]] = [medicines[index + 1], medicines[index]]
        }
        // const replacedElement = document.getElementById(`medicine-${id}`);
        setPrescribedMedicines(medicines)
        setSwapMedicinesToVisit(medicines)
    }

    const onChangeMedicineList = (sortedList) => {
        setPrescribedMedicines(sortedList)
        setSwapMedicinesToVisit(sortedList)
    }


    const setSwapMedicinesToVisit = async (medicines) => {

        clearTimeout(timeoutIdRef.current);
        if (templateId) {
            // timeoutIdRef.current = setTimeout(async () => {
            await put(`/doctor/template/${templateId}`, { "medicines": medicines })
                .then((res) => {
                    if (res.status === 200) {
                        updateState(res?.data)
                        setPrescribedMedicines(res?.data?.medicines)
                    }
                })
                .catch((e) => { })
                .finally(() => { })
            // }, 1500);
        } else {
            // timeoutIdRef.current = setTimeout(async () => {
            await put(`/visit/${visitDetails?._id}`, { "medicines": medicines })
                .then((res) => {
                    if (res.status === 200) {
                        updateState(res?.data)
                        setPrescribedMedicines(res?.data?.medicines)
                    }
                })
                .catch((e) => { })
                .finally(() => { })
            // }, 1500);
        }
    }

    const setPrescriptionMedicineToState = (medicines) => {
        medicines?.map((medicine) => {
            let key = `${"sig-" + medicine?._id}`
            let durationKey = `${"duration-" + medicine?._id}`
            let name = `${"name-" + medicine?._id}`
            setInfo((prev) => ({ ...prev, [key]: medicine?.sig, [durationKey]: medicine?.duration?.replace('/', ' '), [name]: medicine?.name }));

        })

    }


    useMemo(() => {
        if (visitDetails?.medicines) {
            setPrescribedMedicines(visitDetails?.medicines)
            setPrescriptionMedicineToState(visitDetails?.medicines)
        }
        if (templateDetails?.medicines) {
            setPrescribedMedicines(templateDetails?.medicines)
            setPrescriptionMedicineToState(templateDetails?.medicines)
        }
    }, [visitDetails, templateDetails])




    return (
        <div className='prescription-medicine-section'>
            <div className='prescribed-medicine'>
                <div className='med-card-head'>
                    Prescription
                    {prescribedMedicines.length > 0 && <span className='med-badge ' >{prescribedMedicines.length}</span>}
                </div>
                <div className='' style={{ height: "60vh", overflowY: "scroll" }}>
                    <table className="table table-sm table-hover ">

                        <container>
                            <div className="row fw-bold border-bottom py-2 ">
                                <div className="col-1 "><small><strong>#</strong></small></div>
                                <div className="col-3"><small><strong>Name</strong></small></div>
                                <div className="col-3"><small><strong>Sig</strong></small></div>
                                <div className="col-3"><small><strong>Duration</strong></small></div>
                                <div className="col-2"><small><strong>Action</strong></small></div>

                            </div>
                        </container>

                        <tbody className='d-block'>
                            {prescribedMedicines?.length > 0 ? (
                                <DraggableList
                                    items={prescribedMedicines}
                                    onReorder={onChangeMedicineList}
                                    getItemId={(medicine) => medicine?._id}
                                    renderItem={(medicine, index) => (
                                        <table className="table table-sm table-hover my-0" style={{ width: "100%" }}>
                                            <tr className='single-medicine' id={`medicine-${medicine?._id}`}>
                                                <td style={{ width: "5%" }} className='align-middle'><span className='med-num'>{index + 1}</span></td>
                                                <td style={{ width: "25%" }} className='align-middle'>
                                                    <input
                                                        style={{ color: "black" }}
                                                        onChange={(e) => {
                                                            onBlurSetInfo(`${"name-" + medicine?._id}`, e.target.value, "name", medicine?._id)
                                                        }}
                                                        onBlur={(e) => { onBlurSubmit(e.target.value, "name", medicine?._id) }}
                                                        value={info[`${"name-" + medicine?._id}`]}
                                                        type='text'
                                                    />
                                                </td>
                                                <td style={{ width: "40%" }} className='align-middle'>
                                                    <textarea
                                                        onDoubleClick={() => {
                                                            setSelectedMedicine(medicine)
                                                            setShow(true)
                                                            setIsDoubleClick(true)
                                                        }}
                                                        style={{ color: "black", fontWeight: 400 }}
                                                        className="form-control w-100"
                                                        autoComplete="off"
                                                        type="text"
                                                        rows={3}
                                                        placeholder="Sig"
                                                        value={info[`${"sig-" + medicine?._id}`]}
                                                        onChange={(e) => {
                                                            onBlurSetInfo(`${"sig-" + medicine?._id}`, e.target.value, "sig", medicine?._id)
                                                        }}
                                                        onBlur={(e) => { onBlurSubmit(e.target.value, "sig", medicine?._id) }}
                                                    />
                                                </td>
                                                <td style={{ width: "20%" }} className='align-middle'>
                                                    <input
                                                        style={{ color: "black" }}
                                                        type='text'
                                                        onDoubleClick={() => {
                                                            setSelectedMedicine(medicine)
                                                            setShow(true)
                                                            setIsDoubleClick(true)
                                                        }}
                                                        onChange={(e) => {
                                                            onBlurSetInfo(`${"duration-" + medicine?._id}`, e.target.value, "duration", medicine?._id)
                                                        }}
                                                        value={info[`${"duration-" + medicine?._id}`]?.replace('/', ' ')}
                                                        onBlur={(e) => { onBlurSubmit(e.target.value, "duration", medicine?._id) }}
                                                    />
                                                </td>
                                                <td style={{ width: "5%" }} className='text-center'>
                                                    <span className='icon'>
                                                        <FontAwesomeIcon
                                                            onClick={() => { deleteMedicineFun(medicine) }}
                                                            icon={faTrash}
                                                        />
                                                    </span>
                                                </td>
                                            </tr>
                                        </table>
                                    )}
                                />
                            ) : (
                                <tr><td colSpan="5"><small></small></td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='medicine-list'>
                <div className='med-card-head'>Add Medicine</div>
                <div className='med-search-box'>
                    {/* <div className='med-search-label'>Search</div> */}
                    <div className='d-flex mb-1'>
                        <input autoComplete="off" value={searchString} placeholder={`Search by ${searchType}…`} type='text' onChange={(event) => {
                            medicineSearchWithTimeOut(event.target.value, event)
                        }} />
                        <select
                            onChange={(e) => {
                                medicineSearchWithTimeOut('', e)
                                setSearchType(e.target.value);
                            }}
                        >
                            <option value={"name"}> Name</option>
                            <option value={"generic"}>Generic </option>
                        </select>{" "}
                    </div>
                </div>
                <div className='scroll-section'>
                    {medicineList && !docMedicineShow ? medicineList?.map((medicine, index) => {
                        return (
                            <div style={{ cursor: "pointer" }} className={`individual-medicine py-1 border ${checkOrganizationFun(medicine?.manufacturer) == true ? "same_org" : ""}`} key={'drug-search-index-' + index} onClick={() => checkAndAddMedicine(medicine, true)}>
                                <small className='px-1  d-block p-0 m-0 ' style={{ fontWeight: "600", fontSize: "10px", fontStyle: "italic" }}>{medicine?.type?.toLowerCase()}</small>
                                <small className='px-1 ' style={{ fontWeight: "700", color: "black", fontStyle: "italic" }}>{medicine?.name}</small>
                                <small className='px-1 ' style={{ fontWeight: "600", fontSize: "10px", fontStyle: "italic" }}>{medicine?.power?.slice(0, 15)?.toLowerCase()}</small>
                            </div>
                        )
                    }) : ""}

                    <div className='my-drug-list'>
                        {docMedicineShow && <div className='med-search-label med-search-label--list text-primary'>My Drug List</div>}
                        {docMedicineShow && <div className='d-flex px-2 pt-1'>
                            <input value={ownMedicineSearchString || ""} autoComplete="off" style={{ border: ".8px solid black" }} id="my-drug-list" placeholder={`Search from my drugs`} type='text' onChange={(event) => {
                                setOwnMedicineSearchString(event.target.value)
                                medicineSearchFromMyListWithTimeOut(event.target.value, myMedicineSearchType)
                            }} />
                            <select
                                onChange={(e) => {
                                    setOwnMedicineSearchString("")
                                    medicineSearchFromMyListWithTimeOut("", e.target.value)
                                    setMyMedicineSearchType(e.target.value);
                                }}
                            >
                                <option value={"name"}> Name</option>
                                <option value={"generic"}>Generic </option>
                                <option value={"type"}>Type </option>
                            </select>{" "}
                        </div>}
                        {docMedicineShow && doctorMedicineList ? doctorMedicineList?.map((medicine, index) => {
                            return (
                                <div className='d-flex justify-content-between mr-2 individual-medicine' key={'my-drug-list' + index} >
                                    <div className='py-1' style={{ width: "85%" }} onClick={() => {
                                        if (!isSubmitting) checkAndAddMedicine(medicine)
                                    }
                                    }>
                                        <small className='px-1 d-block py-0 my-0' style={{ color: "black", fontSize: "10px", fontStyle: "italic" }}>{medicine?.type?.toLowerCase()}</small>
                                        <small className=' px-1 py-0 my-0' style={{ fontWeight: "700", color: "black", fontStyle: "italic" }}>{medicine?.name}</small>
                                        <small className='px-1 py-0 my-0' style={{ color: "black", fontSize: "10px", fontStyle: "italic" }}>{medicine?.power?.slice(0, 10)?.toLowerCase()}</small>
                                        <small className=' px-1 mb-2 d-block' style={{ color: "black", fontSize: "11px", fontStyle: "italic" }}>{medicine?.sig} {medicine?.duration?.replace('/', ' ')?.length > 0 ? "-" + medicine?.duration?.replace('/', ' ') : ""}</small>
                                    </div>
                                    <FontAwesomeIcon size='xs' className='mt-3' onClick={() => {
                                        setIsDocMedicineUp(true)
                                        setShow(true)
                                        setSelectedMedicine(medicine)
                                    }} icon={faEdit}></FontAwesomeIcon>
                                </div>
                            )
                        }) : ""}
                    </div>
                    {/* {(isNoMedicine && !isLoading && searchString.length >= 0 && !docMedicineShow) ? <small onClick={() => {
                        addNewMedicine(searchString)
                    }} className='d-block px-1'>Create(<span className='text-dark'>{searchString}</span>)</small> : ""} */}
                    {(!isLoading && searchString.length >= 0 && !docMedicineShow) ? <small onClick={() => {
                        addNewMedicine(searchString)
                    }} className='d-block px-1 text-success py-2'>Create(<span className='text-dark'>{searchString}</span>)</small> : ""}
                    {isMedicineListLoading && <small className='px-1'>Loading...</small>}
                    {isDoctorMedicineListLoading && docMedicineShow && <small className='px-1'>Loading...</small>}
                </div>
            </div>
            <CustomModal
                customClass="default"
                size="md"
                show={show}
                setShow={setShow}
                isHeaderHide={true} >
                <MedicineSigForm setPrescriptionMedicineToState={setPrescriptionMedicineToState} templateId={templateId} setPrescribedMedicines={setPrescribedMedicines} visitId={visitDetails?._id} updateState={updateState} isDocMedicineUp={isDocMedicineUp} setIsDocMedicineUp={setIsDocMedicineUp} isDoubleClick={isDoubleClick} setIsDoubleClick={setIsDoubleClick} setDocMedicineShow={setDocMedicineShow} setSearchString={setSearchString} searchString={searchString} doctorId={actingDoctorId} medicineAddToPrescription={medicineAddToPrescription} selectedMedicine={selectedMedicine} setShow={setShow}></MedicineSigForm>
            </CustomModal>
        </div>
    )
}

export default Medicine
